<template>
    <div class="mt-0 flex flex-col min-h-screen bg-gray-200">
        <div class="flex flex-col flex-1">
            <Navigation />
            <div class="md:p-8 p-3 mb-20 flex flex-col">
                <div class="bg-white p-10 mx-auto w-full max-w-3xl shadow">
                    <router-link to="/client" class="text-blue-500">← Retour à mes adhésions</router-link>
                    <div class="mx-auto text-center flex flex-col mt-5">
                        <span class="text-2xl">Déclarer un sinistre</span>

                        <div v-if="!sinisterType">
                            <span class="text-lg text-gray-700">Que s'est-il produit ?</span>

                            <div class="flex md:space-x-5 my-5" >
                                <button class="border bg-gray-100 hover:bg-gray-200 p-5">Casse ou Oxyation</button>
                                <button class="border bg-gray-100 hover:bg-gray-200 p-5">Vol de l'appareil</button>
                                <button class="border bg-gray-100 hover:bg-gray-200 p-5">Crevaison</button>
                                <button class="border bg-gray-100 hover:bg-gray-200 p-5">Reponsabilité civile</button>
                                <button class="border bg-gray-100 hover:bg-gray-200 p-5">Individuel Accident</button>
                            </div>
                        </div>

                        <form @submit.prevent="submitClaim" class="flex flex-col space-y-5 max-w-xs w-full my-5 mx-auto" v-if="sinisterType">
                            <AffInput required label="Date de survenance" type="date" />
                            <AffInput required label="Circonstances" hint="Décrivez les cirsonstances exactes du sinistre" type="textarea" rows="7" />

                            <input type="submit" class="mt-3 mx-auto rounded-full text-sm p-3 px-5 leading-none cursor-pointer border-2 border-xiaomi bg-orange-100 hover:bg-orange-200 text-xiaomi rounded disabled:opacity-75 disabled:cursor-not-allowed  focus:outline-none focus:shadow-outline" value="Valider ma déclaration" />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Navigation from '@/components/client/Navigation'
import AffInput from '@/components/inputs/AffInput'

export default {
    components: { Navigation, AffInput },
    data: function () {
        return {
            sinisterType: null
        }
    },
    methods: {
        submitForm: function () {
            
        }
    }
}
</script>